import { render, staticRenderFns } from "./littleFooter.vue?vue&type=template&id=fc7ab26c&scoped=true"
import script from "./littleFooter.vue?vue&type=script&lang=js"
export * from "./littleFooter.vue?vue&type=script&lang=js"
import style0 from "./littleFooter.vue?vue&type=style&index=0&id=fc7ab26c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7ab26c",
  null
  
)

export default component.exports